// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getProjectWeeklyWeightProgress(projectId: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/weekly_weight_progress_baseline_actual`);
}
